import React, { useEffect } from "react";
import { FaCheck } from "react-icons/fa6";
import { IoIosCloseCircle } from "react-icons/io";
import { IoClose } from "react-icons/io5";

function VanishComponent({
  success,
  error,
  errorFunction,
  successFunction,
  errorMessage,
  successMessage,
  timeOut,
  deleteName,
}) {
  useEffect(() => {
    let timeId;
    let time2Id;
    if (success) {
      timeId = setTimeout(() => {
        successFunction();
      }, [timeOut]);
    }
    if (error) {
      time2Id = setTimeout(() => {
        errorFunction();
      }, [timeOut]);
    }

    return () => {
      if (timeId) {
        clearTimeout(timeId);
      }
      if (time2Id) {
        clearTimeout(time2Id);
      }
    };
  }, [success, error]);

  return (
    <>
      {(error || success) && (
        <div className="fixed top-3 left-0 right-0 flex justify-center items-center z-50">
          <div
            className={`rounded-md  p-4 w-[50%] ${
              success ? "bg-green-200" : "bg-red-200"
            }`}
          >
            <div className="flex">
              <div className="flex-shrink-0">
                {error && (
                  <IoIosCloseCircle
                    className="h-5 w-5 text-red-500"
                    aria-hidden="true"
                  />
                )}
                {success && <FaCheck className="h-5 w-5 text-green-800" />}
              </div>
              <div className="ml-3">
                <h3
                  className={`text-sm font-medium  ${
                    success ? "text-green-800" : "text-red-800"
                  }  `}
                >
                  <span className=" font-bold">
                    {" "}
                    {deleteName ? deleteName : ""}
                  </span>
                  {error ? errorMessage : ""}
                  {success ? successMessage : ""}
                </h3>
              </div>
              <div className=" ml-auto">
                {" "}
                <span
                  onClick={() => {
                    if (error) errorFunction();
                    if (success) successFunction();
                  }}
                  className={`cursor-pointer ${
                    success ? "text-green-800" : "text-red-800"
                  }`}
                >
                  <IoClose />
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VanishComponent;
